import {
  Component,
  Input,
  HostBinding,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChange
} from '@angular/core';
import {
  state,
  style,
  trigger,
  transition,
  animate
} from '@angular/animations';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ui-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          width: '250px'
        })
      ),
      state(
        'closed',
        style({
          width: '60px'
        })
      ),
      transition('open => closed', [
        animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)')
      ]),
      transition('closed => open', [
        animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)')
      ])
    ])
  ]
})
export class SidebarComponent implements OnChanges {
  @Input() items: any[];
  @Input() expanded = true;
  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Output() toggled = new EventEmitter();

  public logoHeight: '100px';

  constructor() {}

  @HostBinding('@openClose')
  sideState;

  ngOnChanges(changes) {
    if (changes.expanded) {
      this.setSideState(changes.expanded.currentValue);
    }
  }

  linkClicked(link) {
    this.selected.emit(link.value);
  }

  toggleSidebar() {
    this.toggled.emit();
  }

  private setSideState(expanded: boolean) {
    this.sideState = expanded ? 'open' : 'closed';
  }
}
